module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header', [_c('h1', [_vm._v(_vm._s(_vm.header))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.subheader))])]), _vm._v(" "), _vm._l((_vm.categories), function(category, key) {
    return [(!category.parentId) ? _c('div', {
      class: ['flexRow categorySummary', category.children && category.showChildren ? 'hasChildren' : '']
    }, [_c('category-details-block', {
      attrs: {
        "category": category,
        "completed": _vm.getCategoryMonthSummary(key, !category.showChildren),
        "quota": _vm.blocksPerDay(key, !category.showChildren),
        "showQuota": false
      }
    }), _vm._v(" "), _c('static-block-row', {
      staticClass: "staticBlockRow",
      attrs: {
        "completed": _vm.getCategoryMonthSummary(key, !category.showChildren),
        "quota": 0,
        "color": category.color
      }
    })], 1) : _vm._e(), _vm._v(" "), (category.showChildren) ? _vm._l((Object.keys(category.children || {})), function(childId) {
      return _c('div', {
        staticClass: "flexRow subcategory"
      }, [_c('subcategory-details-block', {
        attrs: {
          "categoryId": childId
        }
      }), _vm._v(" "), _c('static-block-row', {
        staticClass: "staticBlockRow",
        attrs: {
          "completed": _vm.categories[childId].summaries.month,
          "quota": 0,
          "color": _vm.getCategoryColor(childId)
        }
      })], 1)
    }) : _vm._e()]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4ea66ecb!./~/vue-loader/lib/selector.js?type=template&index=0!./dev/src/views/MonthView.vue
// module id = ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-4ea66ecb!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./dev/src/views/MonthView.vue
// module chunks = 0